import type { IFeatureIslandCategoriesAndManagerStore } from "@/components/features/_layouts/island/main-with-category/store";
import { createFeatureIslandCategoryStore } from "@/components/features/_layouts/island/main-with-category/store/category";
import { createFeatureIslandCategoryManagerStore } from "@/components/features/_layouts/island/main-with-category/store/category-manager";

export class PlanI18nCategoriesAndManagerStore implements IFeatureIslandCategoriesAndManagerStore {
	// 基本設定
	public base = createFeatureIslandCategoryStore({
		title: "プラン名・画像",
		description: "",
		isBasicSetup: true,
	});

	// ここから下は 「追加設定」isBasicSetup: false
	public preQuestions = createFeatureIslandCategoryStore({
		title: "事前質問",
		description: "",
		isBasicSetup: false,
	});

	public email = createFeatureIslandCategoryStore({
		title: "メール",
		description: "",
		isBasicSetup: false,
	});

	public categoryStoreArray = [this.base, this.email, this.preQuestions];

	public categoryManagerStore = createFeatureIslandCategoryManagerStore({
		items: this.categoryStoreArray,
	});
}

export const planI18nCategoriesAndManagerStore = new PlanI18nCategoriesAndManagerStore();
